import React from "react";
import { Card, Item } from "semantic-ui-react";
import "../Css/ArticleTimeLine.css";
import { ArticleItemCard } from "./ArticleItemCard";
import Masonry from "react-masonry-css";

class ArticleTimeLine extends React.Component {
  state = {
    dateTime: "2021/01/01",
    content: {},
  };
  constructor(props) {
    super(props);
    this.state = this.props;
  }
  render() {
    const { dateTime, content } = this.state;
    const date = new Date(dateTime);
    const breakpoints = {
      default: 4,
      1100: 2, //當大小<1000時2
      700: 1, //當大小<700時1
    };

    return (
      <div>
        {/* datetime text */}
        <div className="dateTimeBox">
          {date.getFullYear()}-{date.getMonth()+1}
        </div>
        <div className="contentContainer">
          {/* time line */}
          <div className="line"></div>
          {/* content */}
          <div className="contentBox">

            <Masonry
              breakpointCols={breakpoints}
              className="my-masonry-grid"
              columnClassName="my-masonry-grid_column"
            >
              {content?.map((_item, i) => {
                console.log(content);
                return (
                  <ArticleItemCard
                    aid={_item.aid} 
                    path={_item.path}
                    title={_item.title}
                    meta={_item.meta}
                    date={_item.dateTime}
                    thumbNail={_item.thumbNail}
                  ></ArticleItemCard>
                );
              })}
            </Masonry>
          </div>
        </div>
      </div>
    );
  }
}

export default ArticleTimeLine;
